import { z } from "zod";
import { ALL_ROLES, type Role } from "../constants/roles.js";

export const RoleSchema = z.enum(ALL_ROLES as [Role, ...Role[]]);
